import { render, staticRenderFns } from "./turndown.vue?vue&type=template&id=e8e1add2&scoped=true&"
import script from "./turndown.vue?vue&type=script&lang=js&"
export * from "./turndown.vue?vue&type=script&lang=js&"
import style0 from "./turndown.vue?vue&type=style&index=0&id=e8e1add2&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e1add2",
  null
  
)

export default component.exports